import BookList from '../components/bookList';
import AddBook from '../components/addBook';

const Books = () => (
  <div>
    <BookList />
    <AddBook />
  </div>
);

export default Books;
